import Header from '@/components/common/MainContentHeader';
import useI18n from '../hooks/useI18n';
import { UserContext } from '@/context/UserContext';
import { useContext, useEffect, useState } from 'react';
import MultiStepForm from '@/components/common/MultiStepForm';
import Modal from '@/components/common/models/Model';
import UrlNotExistModal from '@/components/Modal/UrlNotExistModal';
import BrandLogoNotExistModal from '@/components/Modal/BrandLogoNotExistModal';
import { STORAGE_KEYS } from '@/config/storageKeys';
import { useNavigate } from 'react-router-dom';
import ActiveCampaignRunningModal from '@/components/Modal/ActiveCampaignRunningModal';
import { useGetCampaignStatsQuery } from '@/hooks/queries/useCampaignQueries';

const CreateCampaign: React.FC = () => {
  const { t } = useI18n();
  const userContext = useContext(UserContext);

  if (!userContext) {
    throw new Error('useContext must be used within a UserProvider');
  }
  const { user, campaignStats, setCampaignStats } = userContext;

  const [openModal, setOpenModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [activeCampaignModal, setActiveCampaignModal] = useState(false);
  const [campaignBlock, setCampaignBlock] = useState<{
    title: string;
    message: string;
    redirect: string;
    tab?: 'active' | 'paused' | 'draft';
  } | null>(null);

  const navigate = useNavigate();

  const [logoModal, setLogoModal] = useState(false);
  console.log('logoModal', logoModal);

  const brandId = user?.brand?._id || '';

  const { data: campaignStatsData } = useGetCampaignStatsQuery(
    brandId,
    !!brandId,
  );

  useEffect(() => {
    if (campaignStatsData) {
      setCampaignStats(campaignStatsData);
    }
  }, [campaignStatsData]);

  useEffect(() => {
    const isPopupDismissed = localStorage.getItem(
      STORAGE_KEYS.CAMPAIGN_SOCIAL_POPUP_DISMISSED,
    );

    if (campaignStats?.live > 0) {
      setCampaignBlock({
        title: 'Active Campaign Running',
        message: 'You can create a new campaign after the current one ends.',
        redirect: '/active-campaign',
      });
      return;
    }

    if (campaignStats?.paused > 0) {
      setCampaignBlock({
        title: 'Paused campaign Found',
        message:
          'A campaign is paused. Resume it first. You can create a new one after it ends.',
        redirect: '/active-campaign',
        tab: 'paused',
      });
      return;
    }

    if (campaignStats?.scheduled > 0) {
      setCampaignBlock({
        title: 'Campaign Already Scheduled',
        message:
          'A campaign is already scheduled. Edit it if needed. You can create a new one once this campaign is completed.',
        redirect: '/scheduled-campaign',
      });
      return;
    }

    // Existing logic
    if (user?.brand && !user?.instagram && !user?.tiktok && !isPopupDismissed) {
      setOpenModal(true);
      setLogoModal(false);
    }

    if (user?.brand && !user?.brand.brandLogo) {
      setLogoModal(true);
    }
  }, [user, campaignStats]);

  const getSubtitle = () => {
    if (currentStep === 6) {
      return t('common.previewCampaign');
    }
    return t('common.newCampaign');
  };

  const getTitle = () => {
    if (user && user.brand) {
      return `${user.brand.name}'s`;
    }
    return '';
  };

  return (
    <div className="h-full flex flex-col bg-white">
      <div className="p-[24px] lg:bg-[#F0F5FF] bg-white shrink-0">
        <Header title={getTitle()} subtitle={getSubtitle()} />
      </div>
      <div
        className={`bg-white p-[12px] sm:p-[24px] flex-1 min-h-0 flex flex-col ${
          currentStep === 6 ? 'pt-0 sm:pt-0' : ''
        }`}
      >
        <MultiStepForm onStepChange={setCurrentStep} />
      </div>

      <UrlNotExistModal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
          localStorage.setItem(
            STORAGE_KEYS.CAMPAIGN_SOCIAL_POPUP_DISMISSED,
            'true',
          );
        }}
      />
      {campaignBlock && (
        <ActiveCampaignRunningModal
          isOpen={!!campaignBlock}
          title={campaignBlock.title}
          message={campaignBlock.message}
          onClose={() => {
            const { redirect, tab } = campaignBlock;
            setCampaignBlock(null);

            navigate(redirect, {
              state: tab ? { tab } : undefined,
            });
          }}
        />
      )}

      {/* {!openModal && <BrandLogoNotExistModal isOpen={logoModal} />} */}
    </div>
  );
};

export default CreateCampaign;
